'use strict';

angular.module('ntmApp').factory('ListGridHelper', ['$sce', '$templateRequest', 'Utils', 'ListGridStatus', 'ListGridConstants', '$filter',
    function ($sce, $templateRequest, Utils, ListGridStatus, ListGridConstants, $filter) {

    var helper = {};

    helper.getColumnByFieldName = function (name) {
        return ListGridStatus.columns.filter(function (item) { return item.fieldName === name; })[0];
    };

    helper.getColumnByName = function (name) {
        return ListGridStatus.columns.filter(function (item) { return item.name === name; })[0];
    };

    helper.getValueByKey = function (column, value) {
        var result = null;

        (column.values || []).forEach(function (val) {
            column.propertyObj.display.forEach(function (field) {
                if (value && val[field] === value) {
                    result = val;
                }
            });
        });

        return result;
    };

    helper.getDisplayByKey = function (column, value) {

        if (!value) {
            return;
        }

        var result = null;

        (column.values || []).forEach(function (val) {
            if (val && val[column.propertyObj.key].toString() === value.toString()) {
                result = val[column.propertyObj.display[0]];
            }
        });

        return result;
    };

    helper.highlightFilteredHeader = function (row, rowRenderIndex, col) {
        if (col.filters[0].term) {
            return 'header-filtered';
        } else {
            return '';
        }
    };

    helper.toggleFilterDisabling = function (disable) {
        $(".setup-grid .ui-grid-header-cell-wrapper input").prop("disabled", disable);
        $(".setup-grid .ui-grid-header-cell-wrapper select").prop("disabled", disable);
        $(".setup-grid .ui-grid-header-cell-wrapper button").prop("disabled", disable);
    };

    helper.toProperCase = function (str) {
        return str.replace(/(\w)(\w*)/g, function (_, i, r) {
            return i.toUpperCase() + (r !== null ? r : "");
        });
    };

    helper.trustAsHtml = function (html) {
        return $sce.trustAsHtml(html);
    };

    helper.createEmptyRecord = function (addRetainValues, row) {

        var sampleRecord = {};

        ListGridStatus.columns.forEach(function (column) {

            if (sampleRecord[column.name] === undefined) {
                sampleRecord[column.name] = column.type === 'CHECKBOX' ? false : null;
            }

            if (addRetainValues && column.retainSaveAddNew) {
                sampleRecord[column.name] = row[column.name];

                if (column.propertyObj.fields) {

                    column.propertyObj.fields.forEach(function (field) {

                        var childColumn = helper.getColumnByFieldName(field);

                        if (childColumn) {
                            sampleRecord[childColumn.name] = row[childColumn.name];
                        }
                    });
                }
            }
        });

        return sampleRecord;
    };

    helper.getSearchableData = function (column, data) {
        return {
            searchable: column.name,
            placeholder: column.placeholder || 'Search for {0}'.format(column.name.slice(0, -1)),
            values: helper.getGridDataForColumn(column, data)
        };
    };

    helper.getGridDataForColumn = function (column, data) {
        return data.map(function (item) {
            var col = helper.getColumnByFieldName(column.propertyObj.key) || {};
              
            return {
                id: item[col.name],
                value: item[column.name]
            };
        });
    };

    helper.convertToGridData = function (row, model) {

        if (!model) {
            return;
        }

        Object.keys(row).forEach(function (key) {

            var column = helper.getColumnByName(key);

            if (column && angular.isDefined(model[column.fieldName])) {
                helper.convertByColumnType(model, column, row, key);
            }
        });
    };

    helper.convertByColumnType = function (input, column, output, outputPropertyName) {
        switch (column.type) {
            case 'DATE':
                output[outputPropertyName] = input[column.fieldName] ? new Date(input[column.fieldName]) : null;
                break;
            case 'TIME':
                output[outputPropertyName] = moment(input[column.fieldName], 'hh:mm A').isValid() ? new Date(moment(input[column.fieldName], 'hh:mm A')) : null;
                break;
            case ('NUMERIC'):
                if (column.propertyObj.displayAs && (column.propertyObj.displayAs === 'percent' || column.propertyObj.displayAs === 'progressBar')) {
                    output[outputPropertyName] = input[column.fieldName] * 100;
                    if (!output[outputPropertyName] && column.propertyObj.displayAs === 'percent') {
                        output[outputPropertyName] = null;
                    }
                } else {
                    output[outputPropertyName] = input[column.fieldName];
                }
                break;
            case ('RADIOBOOLEAN'):
                output[outputPropertyName] = input[column.fieldName] === true ? 'Yes' : input[column.fieldName] === false ? 'No' : '';
                break;
            case ('CHECKBOXLIST'):
                if (output[outputPropertyName] && angular.isArray(output[outputPropertyName])) {
                    return;
                } else if (input[column.fieldName] && input[column.fieldName].split(';').length > 0) {

                    var values = input[column.fieldName].split(';');
                    var convertedVakues = [];

                    values.forEach(function (value) {
                        if(value && value !== '') {
                            convertedVakues.push(helper.getDisplayByKey(column, value));
                        }
                    });

                    output[outputPropertyName] = convertedVakues.join(';');
                } else {
                    output[outputPropertyName] = input[column.fieldName];
                }
                break;
            default:
                output[outputPropertyName] = input[column.fieldName];
                break;
        }
    };

    helper.getModelByFieldName = function (attributes, model, inputProperty, outputProperty) {

        var result = {};

        if (!model) {
            return result;
        }

        attributes.forEach(function (attribute) {

            if (model[attribute[inputProperty]]) {
                result[attribute[outputProperty]] = model[attribute[inputProperty]];
            }
        });

        return result;
    };

        helper.prepareListboxData = function (property, values) {

        var list = [{ value: '<span class="color-picker-blank">Please Select</span>' }];

            if (property.sort) {
                var order = [];
                property.sort.forEach(function (sortItem) {
                    order.push(sortItem.order === 'DESC' ? '-{0}'.format(sortItem.field) : sortItem.field);
                });
                values = $filter('orderBy')(values, order);
            }

        values.forEach(function (value) {
            var item = { value: '' };
            property.display.forEach(function (name) {
                if (value[name]) {
                    if (value[name].includes('#')) {
                        item.color = value[name];
                        item.value += '<span class="grid-color-sqr" style="background-color:' + value[name] + '">&nbsp;</span>';
                    } else {
                        item.id = value[name];
                        item.value += value[name];
                    }
                }

            });
            item.value = $sce.trustAsHtml(item.value);

            list.push(item);
        });

        return list;
    };

    helper.hasContentMoreThenOneLine = function (html, width) {

        if (html) {
            var div = document.createElement('div');
            div.style.width = width;
            div.style.lineHeight = '28px';
            div.innerHTML = html;

            document.body.appendChild(div);
            var lines = $(div).height() / parseInt(div.style.lineHeight);
            document.body.removeChild(div);

            return (lines > 1);
        }

        return false;
    };

    helper.getNextSequence = function (columnName, entity) {

        var children = ListGridStatus.gridSettings.grouping.getGroupChildren(entity, ListGridStatus.grid.gridOptions.data);

        if (children.length === 0) {
            return 1;
        }

        var record = children.reduce(function (prev, current) {
            return (prev[columnName] > current[columnName]) ? prev : current;
        });

        return record && record[columnName] ? record[columnName] + 1 : 1;
    };

    helper.needToProcess = function (column) {
        return column.type === 'DATE' ||
               column.type === 'TIME' ||
               column.type === 'CHECKBOXLIST' ||
               column.type === 'RADIOBOOLEAN' ||
               column.type === 'NUMERIC' && column.propertyObj.displayAs && (column.propertyObj.displayAs === 'percent' || column.propertyObj.displayAs === 'progressBar');
    };

    helper.processingGridData = function (column, gridData) {

        if (helper.needToProcess(column)) {

            gridData.forEach(function (gridItem) {

                switch (column.type) {
                    case ('NUMERIC'):
                        gridItem[column.name] = gridItem[column.name] ? gridItem[column.name] * 100 : gridItem[column.name];
                        if (!Utils.IsNull(column.decimals) && gridItem[column.name]) {
                            gridItem[column.name] = Number((gridItem[column.name]).toFixed(column.decimals));
                        }
                        break;                   
                    case ('RADIOBOOLEAN'):
                        gridItem[column.name] = gridItem[column.name] === true ? 'Yes' : gridItem[column.name] === false ? 'No' : null;
                        break;
                    case ('DATE'):
                        gridItem[column.name] = gridItem[column.name] ? new Date(gridItem[column.name]) : null;
                        break;
                    case ('TIME'):
                        gridItem[column.name] = gridItem[column.name] ? new Date(moment(gridItem[column.name], 'hh:mm A')) : null;
                        break;
                    case ('CHECKBOXLIST'):
                        gridItem[column.name] = gridItem[column.name] && gridItem[column.name].substr(gridItem[column.name].length - 1) === ';' ? gridItem[column.name].slice(0, -1) : gridItem[column.name];
                        break;
                }
            });
        }
    };

    helper.getPrimaryKeys = function (entity, property) {

        var keys = {};

        ListGridStatus.columns.forEach(function (column) {
            if (column.isPrimary) {
                keys[column.fieldName] =  entity[column[property]];
            }
        });

        return keys;
    };

    helper.getDefaultOptions = function (type) {

        return {
            enableGridMenu: true,
            enableRowSelection: true,
            enableSelectAll: ListGridStatus.gridSettings.multiselect.selectAll(),
            enableRowHeaderSelection: ListGridStatus.gridSettings.multiselect.isEnable(),
            multiSelect: ListGridStatus.gridSettings.multiselect.isEnable(),
            modifierKeysToMultiSelect: false,
            noUnselect: false,
            enableCellEdit: true,
            enableFiltering: true,
            treeRowHeaderAlwaysVisible: false,
            enableColumnMenus: type === ListGridConstants.Types.Dashboard ? true : false,
            enablePaging: ListGridStatus.gridSettings.paging.hasPagination(),
            showFooter: ListGridStatus.gridSettings.paging.hasPagination(),
            paginationPageSize: ListGridStatus.gridSettings.paging.getPageSize(),
            paginationPageSizes: ListGridStatus.gridSettings.paging.getPageSizes(),
            groupingNullLabel: ListGridStatus.gridSettings.grouping.getNullLabel(),
            groupingShowCounts: ListGridStatus.gridSettings.grouping.getShowCounts(),
            rowHeight: 40
        };
    };
       

    helper.getGridRecord = function (records, key, value) {
        return records.filter(r => r.entity[key + '_'] && r.entity[key + '_'].toString() === value.toString())[0];
    };

    helper.doesGridContainRoomHistory = function (sectionId) {
        var gridId = sectionId ? sectionId.toString() : ListGridStatus.gridId.toString();
        var GridsContainingRoomHistory = ListGridConstants.GridsContainingRoomHistory;

        return gridId === GridsContainingRoomHistory.Racks || gridId === GridsContainingRoomHistory.ScheduledActivities;
    };

    helper.getFilteredRoomHistoryRecords = function (records, showRoomHistory, sectionId, updateTabItemsCount) {

        var gridId = sectionId ? sectionId.toString() : ListGridStatus.gridId.toString();
        var FilteringRecordProperty = ListGridConstants.RoomHistoryFilteringRecordProperties;
        var filterByProperty = gridId === ListGridConstants.GridsContainingRoomHistory.Racks ? FilteringRecordProperty.Racks : FilteringRecordProperty.ScheduledActivities;
        var filterBy = updateTabItemsCount ? filterByProperty.fieldName : filterByProperty.displayName;

        if (showRoomHistory) {
            return records;
        }

        var result = records.filter(function (item) {
            return !item[filterBy];
        });

        return result;
    };

    helper.getActionColumn = function () {
        return {
            name: 'action',
            displayName: '',
            cellTemplate: $templateRequest('ng1/src/listGrid/views/rowActions.html'),
            enableSorting: false,
            enableHiding: false,
            enableFiltering: false,
            enableColumnMenu: false,
            width: '70'
        };
    };

    return helper;

}]);
